
export const withActions = func =>
    function (...args) {
        return func(this, ...args)
    }
